export class SpinnerLoaderController {
  loadingMessage: string;

  $onInit() {
    this.loadingMessage = this.loadingMessage || 'Loading'
  }
}